import axios from "axios";
import WebStorageCache from "web-storage-cache";
const sessionCache = new WebStorageCache({storage: "sessionStorage"});      //sessionstorage


var loadingingstace;
//创建axios实例
const ajax = axios.create({
    timeout: 60000
});
//请求拦截,做预处理
ajax.interceptors.request.use( config => {
    // loadingingstace = window.Vue.$loading();                                //开启loading
    config.method = "post";
    return config;
});
//返回拦截,做预处理
ajax.interceptors.response.use( respone => {
    // loadingingstace.close();                                                //关闭loading
    let errorCode = respone.data.ret;
    if (errorCode !== 0) {
      if ( errorCode === 1 || errorCode === 2 || errorCode === 3) {
        window.Vue.$toast({
          type: "fail",
          message:  respone.data.errormessage ? respone.data.errormessage : "未知错误，联系客服!"
        });
      } else {
        window.Vue.$toast({
          type: "fail",
          message:  respone.data.errmsg ? respone.data.errmsg : "服务端请求无返回,请稍候重试!"
        });
      }
    }

    return respone;
}, error => {
    // loadingingstace.close();                                                //关闭loading
    window.Vue.$toast({
      type: "fail",
      message: "服务端请求失败,请稍候重试!"
    });
    return Promise.reject(error)
});
export default ajax;



// WEBPACK FOOTER //
// ./src/utils/ajax.js